/* Move the original rail outside inert main only for the Physics workspace. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.MyersCADPhysicsNavigation=factory();})(typeof window==='object'?window:globalThis,function(){
  function attach({document,main,root,rail,close}){
    let anchor=null;
    function leave(){if(!anchor)return;anchor.before(rail);anchor.remove();anchor=null;rail.classList.remove('physics-tool-rail');}
    function enter(){if(anchor||!rail)return;anchor=document.createElement('div');anchor.hidden=true;rail.before(anchor);document.body.append(rail);rail.classList.add('physics-tool-rail');}
    rail?.addEventListener('click',event=>{
      if(!anchor)return;const button=event.target.closest?.('button');if(!button||button.disabled||button.id==='appSettingsButton')return;
      // Category launchers may be browsed in Physics. Actual modeling commands
      // leave the disposable preview before their original target handlers run.
      if(button.id==='shapesLibraryButton'||button.closest('.railQuickTools,.railGroup'))close();
    },true);
    rail?.addEventListener('keydown',event=>{if(anchor)event.stopPropagation();});
    return {enter,leave};
  }
  return {attach};
});
